define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../domain"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpPrAsset = void 0;
    class FWpPrAsset extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WpPrId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WpPrIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnhanceFAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "EnhanceFAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewAssetTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NewAssetTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Cost", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CostError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Barcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BarcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Qty", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QtyError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FWpPr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemLifeYears", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeYears", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeMonths", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FWpPrAsset.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FWpPr = parent;
            this.WpPrId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.FWpPr = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WpPrId = (0, EntityUtil_1.toInt)(entity.WpPrId);
            a.ChangeType = (0, EntityUtil_1.toInt)(entity.ChangeType);
            a.EnhanceFAssetId = (0, EntityUtil_1.toInt)(entity.EnhanceFAssetId);
            a.NewAssetTypeId = (0, EntityUtil_1.toInt)(entity.NewAssetTypeId);
            a.Cost = (0, EntityUtil_1.toFloat)(entity.Cost);
            a.Barcode = b.Barcode;
            a.Qty = (0, EntityUtil_1.toInt)(entity.Qty);
            a.RemainingLife = (0, EntityUtil_1.toInt)(entity.RemainingLife);
            a.SuggestedLife = (0, EntityUtil_1.toInt)(entity.SuggestedLife);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FWpPrAsset.AliasName);
            this.reset();
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "WpPrId", "Works Project Progress Report ID");
                this.validateReqNumber(validationState, "ChangeType", "Change Type");
                this.validateReqNumber(validationState, "Cost", "Cost of Change", { precision: 2 });
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WpPrId: this.WpPrId,
                ChangeType: this.ChangeType,
                EnhanceFAssetId: this.EnhanceFAssetId,
                NewAssetTypeId: this.NewAssetTypeId,
                Cost: this.Cost,
                Barcode: this.Barcode,
                Qty: this.Qty,
                RemainingLife: this.RemainingLife,
                SuggestedLife: this.SuggestedLife,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        onRemLifeYearChange() {
            this.RemainingLife = (this.RemLifeYears * 12);
        }
        onSuggestedLifeYearChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
        }
        onSuggestedLifeMonthChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
        }
        get EnhanceFAsset() {
            var _a, _b;
            if (this.ChangeType == domain_1.FWpAssetChangeTypeDomain.EnhanceAsset) {
                if ((_b = (_a = this.FWpPr) === null || _a === void 0 ? void 0 : _a.FWorksProject) === null || _b === void 0 ? void 0 : _b.Facility) {
                    return this.FWpPr.FWorksProject.Facility.FAsset.find(a => a.Id == this.EnhanceFAssetId);
                }
            }
            return null;
        }
        get AssetType() {
            var _a, _b, _c;
            if ((_c = (_b = (_a = this.FWpPr) === null || _a === void 0 ? void 0 : _a.FWorksProject) === null || _b === void 0 ? void 0 : _b.Facility) === null || _c === void 0 ? void 0 : _c.AssetTypes) {
                if (this.ChangeType == domain_1.FWpAssetChangeTypeDomain.NewAsset) {
                    return this.FWpPr.FWorksProject.Facility.AssetTypes.find(at => at.Id == this.NewAssetTypeId);
                }
                else if (this.ChangeType == domain_1.FWpAssetChangeTypeDomain.EnhanceAsset) {
                    return this.FWpPr.FWorksProject.Facility.AssetTypes.find(at => at.Id == this.EnhanceFAsset.AssetTypeId);
                }
            }
            return null;
        }
        get TypeDesc() {
            if (this.AssetType) {
                return this.AssetType.AssetTypeDesc;
            }
            else {
                return "";
            }
        }
    }
    exports.FWpPrAsset = FWpPrAsset;
    Object.defineProperty(FWpPrAsset, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FWpPrAsset"
    });
    Object.defineProperty(FWpPrAsset, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Works Project Progress Report Asset"
    });
    Object.defineProperty(FWpPrAsset, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WpPrId", "ChangeType", "EnhanceFAssetId", "NewAssetTypeId", "Cost", "Barcode", "Qty", "RemainingLife", "SuggestedLife"]
    });
    Object.defineProperty(FWpPrAsset, "WpPrIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPrAsset, "ChangeTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPrAsset, "ChangeTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPrAsset, "EnhanceFAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPrAsset, "NewAssetTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPrAsset, "CostReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FWpPrAsset, "BarcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FWpPrAsset, "BarcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPrAsset, "QtyReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPrAsset, "RemainingLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FWpPrAsset, "SuggestedLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "WpPrId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "WpPrIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "ChangeType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "ChangeTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "EnhanceFAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "EnhanceFAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "NewAssetTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "NewAssetTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "Cost", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "CostError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "Barcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "BarcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "Qty", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "QtyError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "RemainingLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "RemainingLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "SuggestedLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "SuggestedLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "FWpPr", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrAsset.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrAsset.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FWpPrAsset.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "RemLifeYears", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "SuggestedRemLifeYears", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FWpPrAsset.prototype, "SuggestedRemLifeMonths", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpPrAsset.prototype, "EnhanceFAsset", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpPrAsset.prototype, "AssetType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FWpPrAsset.prototype, "TypeDesc", null);
});
